import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { getMaintenanceDue } from 'src/api/maintenance';

import StatusBadge from '../ui/StatusBadge';

const badgeConfig = {
  attention: {
    badgeText: 'Service Now',
    badgeVariant: 'error',
  },
  healthy: {
    badgeText: 'Maintained',
    badgeVariant: 'success',
  },
};

const MaintenanceHealthBadge = ({ equipmentUri, className }) => {
  const [loading, setLoading] = useState(true);
  const [config, setConfig] = useState(null);

  useEffect(() => {
    if (!equipmentUri) {
      setConfig(badgeConfig.healthy);
      return;
    }

    setLoading(true);

    const loadMaintenanceDue = async () => {
      try {
        const maintenanceDue = await getMaintenanceDue(equipmentUri);

        // eslint-disable-next-line camelcase
        const needsService = maintenanceDue.some(({ status_indicator }) =>
          ['overdue', 'warning'].includes(status_indicator)
        );

        setConfig(needsService ? badgeConfig.attention : badgeConfig.healthy);
      } catch {
        setConfig(badgeConfig.healthy);
      } finally {
        setLoading(false);
      }
    };

    loadMaintenanceDue();
  }, [equipmentUri]);

  return (
    <div style={{ visibility: loading ? 'hidden' : 'visible' }}>
      <StatusBadge
        variant={config?.badgeVariant ?? badgeConfig.healthy.badgeVariant}
        className={className}
      >
        {config?.badgeText ?? badgeConfig.healthy.badgeText}
      </StatusBadge>
    </div>
  );
};

MaintenanceHealthBadge.propTypes = {
  equipmentUri: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default MaintenanceHealthBadge;
